// extracted by css-extract-rspack-plugin
export default {"wrapper":"UtKlpLFMwITvyTWH","table":"rrsofnIb2SkI2A4J","input":"K9aAlRQeMCspo4D8","table_add":"UjaktaAgaS8tCbo_","button":"kXdGblyMycWCq3GT","buttons":"vE4b4F21UkXlt2uq"};